/// <reference path="compensationSettings.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CompensationSettings {
    class CompensationSettingsController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.CompensationSettingsService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            "meevo.components.short-cuts.ShortCutsService",
            "meevo.components.busy.BusyService",
            "$mdSidenav"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.CompensationSettingsService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $mdSidenav: ng.material.ISidenavService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }


        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.BUSINESSINFO_PAYROLLSETTINGS).then(() => {
                vm.busyService.stop();
                vm.context = new CompensationSettingsContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$mdSidenav);
                super.createContext();
            });
        }

    }

    angular.module("meevo.plugins.compensationSettings")
        .controller("meevo.plugins.compensationSettings.compensationSettingsController", CompensationSettingsController);
}